/**
 * LeftSideSnapshotSelect.js
 * Created by zl952fc on 11/23/2020.
 */

import React, {useState, useEffect, useRef, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {labels} from '../../../util/utils';
import {documentSources} from '../../../util/uiconstants';
import Utility from '../../../util/utilityfunctions';
import {clearFormBodySaveState} from '../../../actions/Form/formBodyActions';
import {anyBodyHasUnsavedChanges} from '../../../selectors/Forms/formBodySelectors';
import EllipseControl from '../../Common/EllipsesControl/EllipsesControl';
import EllipsesMoment from '../../Common/EllipsesControl/EllipseMoment';
import ReactSelect from '../../Common/SelectDropdown/SelectDropdown';
import UnsavedChangesModal from '../UnsavedChangesModal/UnsavedChangesModal';
import {useUserPreferences} from '../../../util/customHooks';

function LeftSideSnapshotSelect(props) {
	const {defaultselectedSnapShot} = props;
	const [snapShotList, setSnapShotList] = useState([]),
		[selectedSnapShot, setSelectedSnapShot] = useState(defaultselectedSnapShot),
		[showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);

	const dispatch = useDispatch();

	const user = useUserPreferences(),
		snapshots = useSelector((store) => store.snapshots),
		hasUnsavedChanges = useSelector((store) => anyBodyHasUnsavedChanges(store));

	const unsavedChangesCallbackData = useRef();

	const formatSnapshots = (snapshots) => {
		let snapshotForDropDown = [];
		let snapShotsFromServer = [];

		snapshotForDropDown.push({value: -1, label: labels.currentVersion, title: labels.currentVersion});
		if (snapshots && snapshots.length > 0) {
			snapShotsFromServer = snapshots.map((item) => {
				let snapshotName;

				switch (item.documentSourceID) {
					case documentSources.RESTORE:
						snapshotName = labels.snapshotRestore;
						break;
					case documentSources.ROLLFORWARD:
						snapshotName = labels.snapshotRollforward;
						break;
					case documentSources.COPYENGAGEMENT:
					case documentSources.COPYCANVASFORM:
						snapshotName = labels.snapshotCopy;
						break;
					default:
						snapshotName = item.userName;
				}

				return {
					value: item.id,
					label: item.userName,
					title: item.userName,
					userName: snapshotName,
					createDate: item.createDate
				};
			}, this);
		}
		if (selectedSnapShot && selectedSnapShot.value !== -1) {
			setSelectedSnapShot(selectedSnapShot);
		} else {
			setSelectedSnapShot(snapshotForDropDown[0]);
		}
		// current snapshot
		snapshotForDropDown.push(...snapShotsFromServer);
		setSnapShotList(snapshotForDropDown);
	};

	const onSnapshotChange = (option) => {
		if (hasUnsavedChanges) {
			unsavedChangesCallbackData.current = option;
			setShowUnsavedChangesModal(true);
		} else {
			performSnapshotChange(option);
		}
	};

	const performSnapshotChange = (option) => {
		if (snapShotList && snapShotList.length > 0) {
			const currentSnapshot = snapShotList.find((fl) => fl.value === option.value);
			setSelectedSnapShot(currentSnapshot);
			props.onSnapshotChange(currentSnapshot);
		}
	};

	const snapshotOptionLabel = ({label, userName, createDate}) => {
		return (
			<section className="selectText">
				{userName ? (
					<>
						<EllipseControl
							id="snapshotOptionNameLabel"
							content={userName}
							tooltip={userName}
							displayId={''}
							noOfLines={1}
						/>{' '}
						<EllipsesMoment
							id="snapshotOptionDateLabel"
							useFormat
							userPreferences={user}
							date={createDate}
							useLocal={false}
						/>
					</>
				) : (
					<EllipseControl id="snapshotOptionLabel" content={label} tooltip={label} displayId={''} noOfLines={1} />
				)}
			</section>
		);
	};

	const onUnsavedChangesStay = useCallback(() => {
		setShowUnsavedChangesModal(false);
		unsavedChangesCallbackData.current = undefined;
	}, []);

	const onUnsavedChangesLeave = useCallback(() => {
		dispatch(clearFormBodySaveState()).then(() => {
			performSnapshotChange(unsavedChangesCallbackData.current);
			setShowUnsavedChangesModal(false);
			unsavedChangesCallbackData.current = undefined;
		});
	}, [dispatch, performSnapshotChange]);

	useEffect(() => {
		formatSnapshots(snapshots);
	}, [snapshots]);

	return (
		<React.Fragment>
			<ReactSelect
				className="CanvasFormChangesSelect"
				formLabel={labels.version}
				groupHeading
				id="Snapshots"
				isSearchable
				formatOptionLabel={snapshotOptionLabel}
				defaultValue={selectedSnapShot}
				options={snapShotList}
				onChange={onSnapshotChange}
				value={selectedSnapShot}
				noOptionsMessage={() => labels.noResultsFound}
				theme={Utility.getTheme()}
			/>
			{showUnsavedChangesModal && (
				<UnsavedChangesModal
					show={showUnsavedChangesModal}
					onCancel={onUnsavedChangesStay}
					onConfirm={onUnsavedChangesLeave}
				/>
			)}
		</React.Fragment>
	);
}

export default LeftSideSnapshotSelect;
